import { FC } from 'react';
import { HTMLChakraProps, Stack } from '@chakra-ui/react';

export const FormSection: FC<HTMLChakraProps<'div'>> = props => (
  <Stack spacing={4} mb={8} {...props}></Stack>
);
